import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import './App.css';
import 'tachyons';

import Multimap from './components/Map';
import Table from './components/Table';
import Footer from './components/Footer';
import Modal from './components/Modal';
import ActionNav from './components/ActionNav';

import { API_URL } from './lib/constants';

// times are in milliseconds
const UPDATE_INTERVAL = 3e5; // 5 min
const TWENTY_FOUR_HOURS = 8.64e7;
const SEVENTY_TWO_HOURS = 2.592e8;

let self;

class App extends Component {
  constructor() {
    super();
    this.state = {
      gaugeGeo: [],
      gaugeRecent: [],
      gaugeDDF: [],
      tableData: [],
      mapGauge: [],
      footerLinks: [],
      updateInterval: {},
      mode: 'gaugeRecent',
      isReplay: false,
      modal: false,
      modalContent: undefined,
      requesttime: PropTypes.instanceOf(Date),
      error: false,
      loading: 4
    };
    self = this;
  }

  componentWillMount() {
    var staticLoader = document.getElementsByClassName('load-kill')[0];
    staticLoader.parentNode.removeChild(staticLoader);
  }

  componentDidMount() {
    let nowTime = Date.now();
    this.setState({requesttime: new Date(nowTime)});
    axios.all([this.getDDF24(nowTime), this.getDDF72(nowTime), this.getGaugeRainfall(nowTime), this.getGaugeGeo()])
      .then(axios.spread( this.processData ))
      .catch((err) => {
        this.setState({error: true});
        throw err;
      });

    this.getFooterLinks();
    let interval = setInterval(this.update, UPDATE_INTERVAL);
    this.setState({updateInterval: interval});
  }

  componentWillUnmount() {
    clearInterval(this.state.updateInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.isReplay !== prevState.isReplay) {
      this.setState({loading: 4});
      if(this.state.isReplay) {
        clearInterval(this.state.updateInterval);
        this.update();
      } else {
        this.update();
        let interval = setInterval(this.update, UPDATE_INTERVAL);
        this.setState({updateInterval: interval});
      }
    }
  }

  update = () => {
    let nowTime = this.state.requesttime.getTime();
    axios.all([this.getDDF24(nowTime), this.getDDF72(nowTime), this.getGaugeRainfall(nowTime)])
      .then(axios.spread( this.processData ))
      .catch((err) => {
        this.setState({error: true});
        throw err;
      });
  }

  processData = (twentyFour, seventyTwo, gaugeRainfall, gaugeGeo) => {

    /*
     * ---- REMOVE VALUES FOR GAUGES ----
     */
    let i, j, k,
        gaugeIDs = []; // array of string gauge IDs

    if (gaugeIDs.length > 0) {
      for (i = 0; i < twentyFour.data.length; i++) { clearItemDDF(twentyFour.data[i], gaugeIDs); }
      for (i = 0; i < seventyTwo.data.length; i++) { clearItemDDF(seventyTwo.data[i], gaugeIDs); }
      for (i = 0; i < gaugeRainfall.data.length; i++) {
        if (gaugeIDs.indexOf(gaugeRainfall.data[i].vaiId) >= 0) {
          for (j = 0; j < gaugeRainfall.data[i].sums.length; j++) {
            gaugeRainfall.data[i].sums[j].sum = null;
          }
        }
      }
    }

    function clearItemDDF(item, ids) {
      if (ids.indexOf(item.id) >= 0) {
        for (j = 0; j < item.durations.length; j++) {
          item.durations[j].rainfall = null;
          for (k = 0; k < item.durations[j].categories.length; k++) {
            item.durations[j].categories[k].description = '-';
            item.durations[j].categories[k].depth = null;
          }
        }
      }
    }
    /*
     * ---- END OF REMOVE VALUES FOR GAUGES ----
     */

    //loading
    if (this.state.loading > 0) {
      let loading = this.state.loading - 4;
      this.setState({loading: loading});
    }

    //ddf
    let ddfData = {
      twentyfour: twentyFour.data,
      seventytwo: seventyTwo.data
    };
    self.setState({gaugeDDF: ddfData});

    //recent rainfall
    gaugeRainfall.data.forEach((g) => {
      g.sums = g.sums.map((s) => {
        if (s.sum >= 500) {
          s.sum = null;
        }
        return s;
      });
    });

    this.setState({gaugeRecent: gaugeRainfall.data});

    let mapGauge = gaugeRainfall.data.map((g, i) => {
      return {
        vaiId: g.vaiId,
        sixHour: g.sums[1].sum,
        sums: g.sums,
        durations: {
          twentyfour: twentyFour.data.find((d) => {
            return g.vaiId === d.id;
          }).durations,
          seventytwo: seventyTwo.data.find((d) => {
            return g.vaiId === d.id;
          }).durations
        }
      };
    });

    this.setState({mapGauge: mapGauge});

    if (this.state.mode === 'gaugeRecent' || this.state.mode === 'radar') {
      this.setState({tableData: gaugeRainfall.data});
    } else {
      this.setState({tableData: ddfData});
    }

    //gauge geo
    if (gaugeGeo) {
      this.setState({gaugeGeo: gaugeGeo.data});
    }
  }

  getGaugeRainfall(endTime) {
    let url = `${API_URL}gaugestatus/sums`;
    return axios({
      method: 'get',
      url: url,
      params: {
        allDurations: true,
        time: endTime
      }
    });
  }

  getDDF24(endTime) {
    let url = `${API_URL}ddf/details/28/${endTime - TWENTY_FOUR_HOURS}/${endTime}`;
    return axios({
      method: 'get',
      url: url
    });
  }

  getDDF72(endTime) {
    let url = `${API_URL}ddf/details/28/${endTime - SEVENTY_TWO_HOURS}/${endTime}`;
    return axios({
      method: 'get',
      url: url
    });
  }

  getGaugeGeo() {
    let url = `${API_URL}gauges/location/markers`;
    return axios({
      method: 'get',
      url: url
    });
  }

  getFooterLinks() {
    this.setState({footerLinks: [
      {
        title: 'MSD Home',
        url: 'http://www.msdgc.org/'
      }, {
        title: 'City of Cincinnati',
        url: 'http://www.cincinnati-oh.gov/cityofcincinnati/'
      }, {
        title: 'Hamilton County',
        url: 'http://www.hamiltoncountyohio.gov/'
      }, {
        title: 'Customer Service',
        url: 'mailto:help@vieuxinc.com'
      }
    ]});
  }

  toggleReplay = (newDate) => {
    this.setState({isReplay: !this.state.isReplay});
    if (newDate instanceof Date) {
      this.setState({requesttime: newDate});
    }
  }

  handleModeSwitch = (mode) => {
    this.setState({mode: mode});

    let isDDF = mode === 'gaugeDDF' ? true : false;

    if (isDDF) {
      this.setState({tableData: this.state.gaugeDDF});
    } else {
      this.setState({tableData: this.state.gaugeRecent});
    }
  }

  handleModalActivate = (disclaimer) => {
    if (disclaimer) {
      this.setState({modalContent: disclaimer});
    } else {
      this.setState({modalContent: this.state.mode});
    }
    let value = !this.state.modal;
    this.setState({modal: value});
  }

  render() {
    let content;
    if (this.state.loading > 0 || this.state.error) {
      let error;
      if (this.state.error) {
        error = (
          <div className="tc">
            <h2>We've encountered an error. The site is currently unavailable.</h2>
          </div>
        )
      }
      content = (
        <section>
          <div className="spinner">
            <div className="dot1"></div>
            <div className="dot2"></div>
          </div>
          {error}
        </section>
      );
    } else {
      content = (
        <div>
          <Multimap mode={this.state.mode} gaugegeo={this.state.gaugeGeo} gaugerecent={this.state.mapGauge} requesttime={this.state.requesttime} isreplay={this.state.isReplay} />
          <ActionNav mode={this.state.mode} modeswitch={this.handleModeSwitch} />
          <Table mode={this.state.mode} data={this.state.tableData} requesttime={this.state.requesttime} isreplay={this.state.isReplay} handlereplay={this.toggleReplay} modalactivate={this.handleModalActivate} modeswitch={this.handleModeSwitch} />
          <Footer links={this.state.footerLinks} modalactivate={this.handleModalActivate} />
          <Modal mode={this.state.modalContent} active={this.state.modal} modalactivate={this.handleModalActivate} />
        </div>
      )
    }
    return (
      <main className="h-100 relative">
        {content}
      </main>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js